import React from "react"
import "./NavBar.css"

export default function NavBar() {
    // function expand() {
    //     const topNav = document.getElementById("top-nav");
    //     if (topNav.className.includes("expand")) {
    //       topNav.classList.remove("expand");
    //     } else topNav.classList.add("expand");
    //   }

    return (
        <nav id="top-nav">

        {/* <a className="nav-brand" href="https://dailyprincetonian.com">
        THE DAILY PRINCETONIAN </a> */}

            <a href="https://dailyprincetonian.com">
            <img className="logo" alt="The Daily Princetonian logo" src="https://dirgyzwl2hnqq.cloudfront.net/8ab5ccf6483af37484451354a9d9e4e3/dist/img/prince_logo_scrolled.png" />
            </a>
            <span className="project-name">&nbsp;|&nbsp;colors of princeton</span>



        {/* <span className="menu-icon" onClick={expand}>&#9776;</span>
        <div className="nav-links">
        <a href="demographics.html">Demographics</a>
        <a href="academics.html">Academics</a>
        <a href="lifestyle.html">Lifestyle</a>
        <a href="views.html">Views</a>
        <a href="covid.html">COVID</a>
        <a href="methodology.html">About</a>
        </div> */}
        </nav>
    )
}